export const API_VERSIONS = {
  VERSION_2026_06_30: "2026-06-30",
} as const;

export const LATEST_API_VERSION = API_VERSIONS.VERSION_2026_06_30;
